module.exports = __webpack_public_path__ + "static/media/appstore.445ecd84.png";